import { takeEvery, put } from "redux-saga/effects";
import { request2, request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import { store } from "../../store";
export default function* watcherAddProductPriceSaga() {
  yield takeEvery("ADD_PRODUCT_SALES_PRICE", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    console.log("Product Sales Price Payload", action.payload);
    var url = "/add-product-sale-price";
    yield request("post", action.payload, url).then((response) => {
      payload = response;
    });
    toast.success(payload);

    let formatUrl = "get-all-product-sale-price";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "PRODUCT_SALESPRICE_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("add-product-price-saga", e);
    yield put({ type: "DISPLAY_LOADER" });
    console.log("add-product-price-saga", e.response);
    console.log(e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
